import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {GlobalDataService} from "../../../service/global-data.service";
import {TranslationService} from "../../../service/translation.service";
import {TitleWrapperService} from "../../../service/title-wrapper.service";

export type ErrorDetails = {
  title: string;
};


@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  errorDetails: undefined | ErrorDetails;

  constructor(
    private activatedRoute: ActivatedRoute,
    private globalDataService: GlobalDataService,
    private translationService: TranslationService,
    private titleService: TitleWrapperService,
  ) {
  }

  ngOnInit(): void {
    this.updateTitle();
    this.activatedRoute.params.subscribe(parameters => {
      switch (parseInt(parameters["code"])) {
        case 404:
          this.errorDetails = {
            title: this.translationService.trans("error.error_not_found", "Page not found"),
          };
          break;
        default:
          this.errorDetails = {
            title: this.translationService.trans("error.error_general", "Unknown error, try again later"),
          };
          break;
      }
      this.updateTitle();
    });
  }

  private updateTitle() {
    const basePageName = this.translationService.trans("error.page_title", "Error");
    if (this.errorDetails) {
      this.titleService.setPageName(`${basePageName} - ${this.errorDetails.title}`);
    } else {
      this.titleService.setPageName(basePageName);
    }
  }

}
